module.exports = __webpack_public_path__ + "static/media/400150_01.c4af171c.png";